import {Heading} from 'platform/foundation';

import i18n from '@dms/i18n';

import {DimensionsGroup} from '../../kit/groups/DimensionsGroup';
import {LoadingSpaceDimensionsGroup} from '../../kit/groups/LoadingSpaceDimensionsGroup';
import {isTrailerOrSemitrailer} from '../../kit/utils/isTrailerOrSemitrailer';
import {isVanOrTruck} from '../../kit/utils/isVanOrTruck';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function DimensionsWeightSubSection() {
  return (
    <VFKit.SubSection data-testid="dimensions-weight">
      <Heading size={4}>{i18n.t('entity.vehicle.labels.dimensions')}</Heading>
      <VFKit.ShowWhen
        name="type"
        condition={(type) => isVanOrTruck(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
      >
        <VFKit.Group data-testid="dimensions" columns={[1, 2, 4]}>
          <VFKit.DimensionLengthSelect />
          <VFKit.DimensionsHeightOptions />
        </VFKit.Group>
      </VFKit.ShowWhen>
      <VFKit.Group data-testid="dimensions" columns={[1, 2, 4]}>
        <DimensionsGroup />
        <VFKit.ShowWhen
          name="type"
          condition={(type) => isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
        >
          <VFKit.SimpleNumericField name="europalletStorageSpaces" />
        </VFKit.ShowWhen>
        <VFKit.ShowWhen
          name="type"
          condition={(type) => !isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
        >
          <div />
        </VFKit.ShowWhen>
        <VFKit.ShowWhen
          name="type"
          condition={(type) =>
            isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR') ||
            isVanOrTruck(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')
          }
        >
          <LoadingSpaceDimensionsGroup />
        </VFKit.ShowWhen>
      </VFKit.Group>

      <VFKit.Group data-testid="weight" columns={[1, 2, 4]}>
        <VFKit.SimpleNumericField name="operatingWeight" />
        <VFKit.SimpleNumericField name="weight" />
        <VFKit.ShowWhen name="type" condition={(type) => type?.at(0) !== 'VEHICLETYPE_SEMI_TRUCK'}>
          <VFKit.SimpleNumericField name="maximalLoadCapacity" />
        </VFKit.ShowWhen>
      </VFKit.Group>

      <VFKit.Group data-testid="trunk-wheelbase" columns={[1, 2, 4]}>
        <VFKit.ShowWhen
          name="type"
          condition={(type) =>
            !isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR') &&
            type?.at(0) !== 'VEHICLETYPE_SEMI_TRUCK'
          }
        >
          <VFKit.SimpleNumericField name="trunkSpace" />
        </VFKit.ShowWhen>
        <VFKit.SimpleNumericField name="wheelBase" />
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
